<template>
  <div style="overflow-x:hidden;">

    <!-- ═══ PAGE HERO ═══ -->
    <div class="nf-page-hero">
      <h1>Contact Us</h1>
      <ul class="nf-breadcrumb">
        <li><router-link to="/">Home</router-link></li>
        <li class="sep"><i class="fas fa-chevron-right" style="font-size:.65rem;"></i></li>
        <li class="active">Contact</li>
      </ul>
    </div>

    <!-- ═══ CONTACT FORM ═══ -->
    <section class="py-6 px-3 px-lg-5 nf-section-lines">
      <div class="container-fluid">
        <div class="text-center mb-5 nf-reveal">
          <span class="section-label">Reach Out</span>
          <h2 class="section-title">Get in Touch</h2>
          <hr class="section-divider" />
          <p class="text-muted mx-auto" style="max-width:560px;">
            Have a question, project in mind, or want to learn more about our work? We'd love to hear from you.
          </p>
        </div>

        <div class="row g-5 justify-content-center align-items-start">

          <!-- Quick info -->
          <div class="col-12 col-lg-4 nf-reveal-left">
            <div class="nf-contact-info nf-stagger">
              <div class="nf-contact-item" v-for="(info, i) in contactInfo" :key="i">
                <div class="nf-ci-icon"><i :class="info.icon"></i></div>
                <div>
                  <h6 class="mb-1">{{ info.label }}</h6>
                  <a v-if="info.href" :href="info.href" class="text-muted text-decoration-none small nf-ci-link">{{ info.value }}</a>
                  <span v-else class="text-muted small">{{ info.value }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Form -->
          <div class="col-12 col-lg-8 nf-reveal-right">
            <div class="nf-form-panel">
              <form @submit.prevent="submitForm">
                <div class="row g-3">
                  <div class="col-12 col-sm-6">
                    <div class="form-floating">
                      <input type="text" class="form-control" id="ct-name" placeholder="John Doe" v-model="form.full_name" required />
                      <label for="ct-name">Full Name</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-floating">
                      <input type="email" class="form-control" id="ct-email" placeholder="email@example.com" v-model="form.email" required />
                      <label for="ct-email">Email Address</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <input type="text" class="form-control" id="ct-subject" placeholder="Subject" v-model="form.subject" required />
                      <label for="ct-subject">Subject</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <textarea class="form-control" id="ct-msg" placeholder="Your message…" style="height:160px;" v-model="form.message" required></textarea>
                      <label for="ct-msg">Your Message</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <button class="btn btn-primary w-100 py-3 rounded-pill" type="submit" :disabled="submitting">
                      <span v-if="!submitting"><i class="fas fa-paper-plane me-2"></i>Send Message</span>
                      <span v-else><i class="fas fa-spinner fa-spin me-2"></i>Sending…</span>
                    </button>
                  </div>
                </div>
              </form>
              <div v-if="error"   class="mt-3 p-3 rounded-3 small fw-semibold nf-alert-error">
                <i class="fas fa-exclamation-circle me-2"></i>{{ error }}
              </div>
              <div v-if="success" class="mt-3 p-3 rounded-3 small fw-semibold nf-alert-success">
                <i class="fas fa-check-circle me-2"></i>{{ success }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ═══ OUR OFFICES ═══ -->
    <section class="py-6 px-3 px-lg-5 nf-section-dots">
      <div class="container-fluid">
        <div class="text-center mb-5 nf-reveal">
          <span class="section-label">Find Us</span>
          <h2 class="section-title">Our Offices</h2>
          <hr class="section-divider" />
        </div>

        <div v-if="!offices.length" class="text-center py-5 text-muted">
          <i class="fas fa-spinner fa-spin me-2"></i>Loading offices…
        </div>
        <div v-else class="row g-4 justify-content-center nf-stagger">
          <div class="col-12 col-md-6 col-lg-4" v-for="office in offices" :key="office.id">
            <div class="nf-office-card">
              <div class="office-icon"><i class="fas fa-building"></i></div>
              <h5 class="mb-3 text-primary">{{ office.office_name }}</h5>
              <div class="nf-office-row">
                <i class="fas fa-map-marker-alt text-primary"></i>
                <span>{{ office.address }}</span>
              </div>
              <div class="nf-office-row">
                <i class="fas fa-phone-alt text-primary"></i>
                <a :href="'tel:'+office.phone" class="text-decoration-none text-muted">{{ office.phone }}</a>
              </div>
              <div class="nf-office-row">
                <i class="fas fa-envelope text-primary"></i>
                <a :href="'mailto:'+office.email" class="text-decoration-none text-muted">{{ office.email }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'ContactView',
  data() {
    return {
      form: { full_name: '', email: '', subject: '', message: '' },
      submitting: false,
      error: null,
      success: null,
      offices: [],
      contactInfo: [
        { icon:'fas fa-envelope',     label:'Email Us',      href:'mailto:enquiries@nexusfocusconsultancy.com', value:'enquiries@nexusfocusconsultancy.com' },
        { icon:'fas fa-phone-alt',    label:'Call Us',       href:'tel:+254729768692',                         value:'+254 729 768 692' },
        { icon:'fas fa-map-marker-alt',label:'Our Location', href:null,                                        value:'Nairobi, Kenya' },
        { icon:'fas fa-clock',        label:'Working Hours', href:null,                                        value:'Mon – Fri, 8:00 AM – 5:00 PM EAT' },
      ],
    };
  },
  mounted() {
    this.fetchOffices();
  },
  methods: {
    async fetchOffices() {
      try {
        const res  = await fetch('https://admin.nexusfocusconsultancy.com/contact/api/offices/');
        this.offices = await res.json();
        this.$nextTick(() => window.dispatchEvent(new Event('nf-reobserve')));
      } catch (e) {
        console.error('Failed to load offices:', e);
      }
    },
    async submitForm() {
      this.submitting = true;
      this.error = null; this.success = null;
      try {
        const res = await fetch('https://admin.nexusfocusconsultancy.com/contact/api/contacts/new/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.form),
        });
        if (!res.ok) {
          const e = await res.json();
          throw new Error(e.detail || 'Submission failed.');
        }
        this.success = 'Your message was sent successfully. We\'ll get back to you shortly!';
        this.form = { full_name:'', email:'', subject:'', message:'' };
      } catch (e) {
        this.error = e.message;
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
/* Contact info sidebar */
.nf-contact-info { display:flex; flex-direction:column; gap:1.5rem; }
.nf-contact-item {
  display:flex; align-items:flex-start; gap:1rem;
  padding:1.25rem 1.5rem;
  background:#fff;
  border-radius:12px;
  border:1px solid var(--nf-border,#dce8e0);
  transition:box-shadow .3s;
}
.nf-contact-item:hover { box-shadow:0 8px 24px rgba(26,107,74,0.1); }
.nf-ci-icon {
  width:44px; height:44px; flex-shrink:0;
  border-radius:50%;
  background:var(--nf-green-tint,#e7f4ed);
  display:flex; align-items:center; justify-content:center;
  font-size:1rem; color:var(--nf-green,#1a6b4a);
}
.nf-ci-link:hover { color:var(--nf-green,#1a6b4a) !important; }

/* Office rows */
.nf-office-row {
  display:flex; align-items:center; gap:.75rem;
  padding:.6rem 0;
  border-bottom:1px solid var(--nf-border,#dce8e0);
  font-size:.88rem;
}
.nf-office-row:last-child { border-bottom:none; }
.nf-office-row i { width:16px; text-align:center; flex-shrink:0; }

.nf-alert-success { background:#e7f4ed; color:#1a6b4a; }
.nf-alert-error   { background:#fce8e8; color:#c0392b; }
</style>
